// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins';
import { socialClubMixins } from '@/app/mixins/modules/social-club-mixins';

// Third Party Libraries
const VueGallerySlideshow = () => import(/* webpackPrefetch: true, webpackChunkName: "vue-gallery-slideshow"*/ 'vue-gallery-slideshow');
const ModalReactionSummary = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-reaction-summary"*/ '@/app/views/main-view/social/components/modals/modal-reaction-summary/modal-reaction-summary.vue');

// Services
import CommentService from '@/app/services/main/comments/comments-service.js';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

export default {
    name: 'SocialViewClubFeedsComponent',
    components: {
        VueGallerySlideshow,
        ModalReactionSummary
    },
    mixins: [
        toastMessageMixins,
        dateMixins,
        userMixins,
        socialClubMixins
    ],
    props: {
        feedContent: {
            type: Object
        }
    },
    data() {
        return {
            commentInput: '',
            index: null,
            commentIndex: null,
            comments: [],
            isCreatingComment: false,
            options: {
                limit: 3,
                offset: 0
            },
            commentCount: 0,
            commentShowStatus: 'more',
            seeMoreClicked: false,
            isFetchingComments: false,
            reactions: [
                {id: 1, type: require('@/assets/images/social-club/like.png'), active: true}
            ],
            reactionDetails: {
                totalReactionCount: 0,
                countPerReactionType: [],
            }
        }
    },
    computed: {
        getPosterInitials() {
            const { firstName, lastName } = this.feedContent;
            let userInitials = '';

            if (firstName && lastName) {
                userInitials = `${firstName.charAt(0)}${lastName.charAt(0)}`
            }

            return userInitials;
        },
        getMediaLinks() {
            return this.feedContent.mediaFiles.map(({ location }) => location);
        },
        getDisplayingComments() {
            if (this.commentShowStatus === 'more') {
                return this.comments.filter((_, index) => index < 3);
            }

            return this.comments;
        },
        getCommentShowStatus() {
            return this.commentShowStatus === 'more' ? 'Show more comments' : 'Show less comments';
        },
        getActiveReaction() {
            return  {type: require('@/assets/images/social-club/like.png'),  active: true};
        },
    },
    created() {
        if (!this.feedContent.newPost) {
            this.getComments();
        }
    },
    methods: {
        async getComments() {
            if (!this.isFetchingComments) {
                this.isFetchingComments = true;

                const { data: { comments, commentCount, reactions } } = await CommentService.getComments({
                    offset: this.options.offset,
                    limit: this.options.limit,
                    postId: this.feedContent.id
                });

                this.commentCount = commentCount;
                this.comments = this.comments.concat(comments);

                this.reactionDetails = reactions;

                this.isFetchingComments = false;
            }
        },
        async deleteComment(deletedComment) {
            const { value } = await this.$swal({
                imageHeight: '150px',
                imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
                imageAlt: 'Confirm Dog',
                titleText: `Delete Comment`,
                html: `<p>Are you sure you want to delete this comment?</p>`,
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                showCancelButton: true,
				showCloseButton: true,
                customClass: {
                    header: 'header-social-club',
                    title: 'title-social-club'
                },
                reverseButtons: true
            });

            if (value) {
                CommentService.deleteComment(deletedComment.id)
                    .then( res => {
                        if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                            this.comments = this.comments.filter(comment => deletedComment.id !== comment.id);
                            if (!this.seeMoreClicked) {
                                this.options.offset -= 1;
                            }
                        } else {
                            this.showCustomErrorToast(this.toastMessages.comment().ERROR_DELETE_COMMENT);
                        }
                    });
            }
        },
        seeMoreOrLessClicked() {
            if (this.commentCount > 3 && this.comments.length < this.commentCount && this.commentShowStatus === 'more') {
                this.options = {
                    limit: 0,
                    offset: this.options.offset + 3
                };

                this.getComments();
            }

            this.seeMoreClicked = true;
            this.commentShowStatus = this.commentShowStatus === 'more' ? 'less' : 'more';
        },
        getCommenterInitials(commenter) {
            return `${commenter.firstName.charAt(0)}${commenter.lastName.charAt(0)}`;
        },
        async showDeleteAlert() {
            const { value } = await this.$swal({
                imageHeight: '150px',
                imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
                imageAlt: 'Confirm Dog',
                titleText: `Delete Post`,
                html: `<p>Are you sure you want to delete this post?</p>`,
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                showCancelButton: true,
				showCloseButton: true,
                customClass: {
                    header: 'header-social-club',
                    title: 'title-social-club'
                },
                reverseButtons: true
            });

            if (value) {
                this.$emit('deletePostCallback', this.feedContent.id);
            }
        },
        showModalReactionSummary() {
            this.$refs.reactionSummaryModal.openModal();
        }
    }
}